import shiftRequestService from "../services/shiftRequestService";
import {action} from "mobx";
import appStore from "./appStore";
import {message} from "antd";

class shiftRequestStore {
    @action getShiftRequests = async params => {
        try {
            const resultOfRequest = await shiftRequestService.getShiftRequest(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action createShiftRequest = async params => {
        try {
            const resultOfRequest = await shiftRequestService.createShiftRequest(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            message.success(`Vardiya talebi oluşturuldu.`);
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action deleteShiftRequest = async params => {
        try {
            const resultOfRequest = await shiftRequestService.deleteShiftRequest(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            message.success(`Vardiya talebi silindi.`);
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action updateShiftRequest = async params => {
        try {
            const resultOfRequest = await shiftRequestService.updateShiftRequest(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            message.success(`Vardiya talebi güncellendi.`);
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action updateShiftRequestByOperation = async params => {
        try {
            const resultOfRequest = await shiftRequestService.updateShiftRequestByOperation(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }

            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };
}

export default new shiftRequestStore();
